module.exports = __webpack_public_path__ + "img/logo-barriorojas.9d35b5f7.png";